import { SerializedEditorState } from 'lexical';
import { useMemo } from 'react';
import { TextEditorHandler } from '../handlers/textEditorHandler';

const textEditorHandler = TextEditorHandler.instance;

type GetEditorStateFnOrKeyType =
  | (() => SerializedEditorState | string | null)
  | string;

type MarkdownObject = { markdown: string | null };

export function useEditorStateToMarkdown(
  getEditorStateFnOrKey: GetEditorStateFnOrKeyType,
  deps: any[],
): MarkdownObject {
  const editorState = useMemo(() => {
    if (typeof getEditorStateFnOrKey === 'string')
      return textEditorHandler.getEditorStateFromLocalStorage(
        getEditorStateFnOrKey,
      )?.editorState;

    return getEditorStateFnOrKey();
  }, deps);

  if (!editorState) return { markdown: null };

  let parsedEditorState: SerializedEditorState =
    typeof editorState === 'string' ? JSON.parse(editorState) : editorState;

  const markdown = textEditorHandler.convertToMarkdown(parsedEditorState);

  return { markdown };
}
